import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import {useEffect} from 'react'
import {useAppActions} from '../../../hooks/runtime'

export const useCheckoutCacheListener = () => {
  const {navigateToDetails, navigateToDetailsOld} = useAppActions()

  const {experiments} = useExperiments()
  const useReduxToolkitEnabled = experiments.enabled(ExperimentNames.UseDetailsPageReduxToolkit)

  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        useReduxToolkitEnabled ? navigateToDetails() : navigateToDetailsOld()
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])
}
